import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {RightPanelSectorTitleProps} from './right-panel-sector-title.types';
import styles from './right-panel-sector-title.module.scss';

export function RightPanelSectorTitle({title}: RightPanelSectorTitleProps): ReactElement {
  return <Text val={title} size={TextSize.LG} bold className={styles.title} />;
}
